var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.008,
    height: 12.001,
    viewBox: "0 0 22.008 12.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#662d91;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M101.93,402.915h10a6,6,0,1,1-4.475,10h-1.061a6,6,0,1,1-8.944-8h0a6,6,0,0,1,4.474-2m-1,3v2h-2v2h2v2h2v-2h2v-2h-2v-2h-2m9.5,3a1.5,1.5,0,1,0,1.5,1.5,1.5,1.5,0,0,0-1.5-1.5m3-3a1.5,1.5,0,1,0,1.5,1.5,1.5,1.5,0,0,0-1.5-1.5Z",
    transform: "translate(-95.922 -402.915)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon_play.78f50899b0bab8fff9a10559d083dbd4.svg";
export { ForwardRef as ReactComponent };